{
  "title": "Antagonize",
  "source": "The Book of Many Things",
  "levelAndSchool": "3rd-Level Enchantment",
  "level": 3,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S, M (a playing card depicting a rogue)",
  "duration": "Instantaneous",
  "description": [
    "You whisper magical words that antagonize one creature of your choice within range. The target must make a Wisdom saving throw. On a failed save, the target takes 4d4 psychic damage and must immediately use its reaction to make a melee attack against another creature of your choice that you can see. If the target can’t make this attack (for example, because there is no one within its reach or because its reaction is unavailable), the target instead has disadvantage on the next attack roll it makes before the start of your next turn. On a successful save, the target takes half as much damage only.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, the damage increases by 1d4 for each slot level above 3rd."
  ],
  "spellLists": ["bard", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
